import { useEffect, useState } from 'react';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';

const useFulfilmentLocations = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchLocations = async () => {
      try {
        const response = await fulfilmentApi.listFulfilmentLocations(
          {},
          {
            headers: {
              'x-page-size': 250,
            },
          },
        );
        const { data = [] } = response;

        if (isMounted) {
          setLocations(data);
        }
      } catch (err) {
        if (isMounted) {
          setLocations([]);
        }
      }
    };

    fetchLocations();

    return () => {
      isMounted = false;
    };
  }, []);

  return locations;
};

export default useFulfilmentLocations;
